import React from 'react';
import ReactDOM from 'react-dom';
import dataFetcher from './helpers/data_fetcher';
import App from './App';

const mountElement = document.getElementById('photo_gallery');

const initialiseApp = ([photos, video]) => {
  if (video.type === undefined) {
    video = null;
  }
  if (photos.length >= 1) {
    ReactDOM.render(<App photos={photos} video={video} />, mountElement);
  }
};

if (mountElement) {
  Promise.all([dataFetcher.getPhotos(), dataFetcher.getVideo()]).then((data) =>
    initialiseApp(data),
  );
}
